import { jsx as e } from "react/jsx-runtime";
import { forwardRef as s } from "react";
import { SearchField as h } from "./index.es45.js";
import { UnifiedInputField as l } from "./index.es62.js";
import { Icon as a } from "./index.es157.js";
const x = s(
  ({ disabled: r, inputType: p, testId: o, setValue: t, onClick: n, onBlur: f, ...i }, m) => p === "searchfield" ? /* @__PURE__ */ e(
    h,
    {
      ...i,
      shouldBlurOnEnter: !1,
      ref: m,
      onChange: t,
      onClick: n,
      testId: `${o}-search-field`,
      onBlur: f,
      disabled: r
    }
  ) : /* @__PURE__ */ e(
    l,
    {
      ...i,
      shouldBlurOnEnter: !1,
      ref: m,
      testId: `${o}-search-field`,
      onBlur: f,
      onChange: t,
      onClick: n,
      disabled: r,
      RightIcon: /* @__PURE__ */ e(a, { type: "MagnifyingGlass", disabled: r, size: 24 })
    }
  )
);
export {
  x as AutoCompleteInput
};
//# sourceMappingURL=index.es2472.js.map
